export default {
  placeholder: 'Wybierz system jednostek',
};
